import { render, staticRenderFns } from "./Datatable.vue?vue&type=template&id=6609219d&"
import script from "./DatatableScript.js?vue&type=script&lang=js&"
export * from "./DatatableScript.js?vue&type=script&lang=js&"
import style0 from "./Datatable.vue?vue&type=style&index=0&id=6609219d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports